import { FaEye, FaRegEdit, FaTrashAlt, FaPlus, FaImages, FaExchangeAlt } from "react-icons/fa";
import Pagination from '@mui/material/Pagination';
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import ButtonIcon from "components/ButtonIcon";
import TableComponent from "components/Table";
import { TourWrapper } from "./styled"
import { tourSelector, tourTypeSelector } from 'redux/selector'
import { tourActions } from 'redux/slice/tourSlice'
import { tourTypeActions } from 'redux/slice/tourTypeSlice'
import Modal from "./Modal";
import FormSearch from "components/FormSearch";
import useDebounce from 'hooks/useDebounce'
import ModalImageDescription from "./ModalImageDescription"
import ModalSchedule from "./ModalSchedule"
import { setPrice } from "utils";
import Loading from "components/Loading";

const Tour = () => {
    document.title = 'Quản lý tour'
    const location = useLocation()
    const query = new URLSearchParams(location.search)
    const qPage = query.get("page")
    const navigate = useNavigate()

    const [showModal, setShowModal] = useState(false)
    const [currentPage, setCurrentPage] = useState(qPage ? parseInt(qPage) : 1)
    const tourState = useSelector(tourSelector)
    const tourTypeState = useSelector(tourTypeSelector)
    const dispatch = useDispatch()
    const [method, setMethod] = useState('add')
    const [selectedId, setSelectedId] = useState(null)
    const [totalItemInPage, setTotalItemInPage] = useState(0)
    const [tourType, setTourType] = useState('all')
    const [sort, setSort] = useState('DESC')
    const [queryInput, setQueryInput] = useState('')
    const querySearch = useDebounce(queryInput, 500)
    const [showModalImg, setShowModalImg] = useState(false)
    const [selectedIdImg, setSelectedIdImg] = useState(null)
    const [showModalSchedule, setShowModalSchedule] = useState(false)
    useEffect(() => {
        dispatch(tourTypeActions.getTourTypeAll())
    }, [dispatch])

    useEffect(() => {
        dispatch(tourActions.getTour({ query: querySearch, sort, currentPage, tourType }))
    }, [tourType, currentPage, dispatch, querySearch, sort])

    const handleChangeTourType = (e) => {
        if (currentPage > 1) {
            setCurrentPage(1)
            navigate(`/admin/tour?page=1`)
        }
        setTourType(e.target.value)
    }

    const handleChangeSort = (e) => {
        if (currentPage > 1) {
            setCurrentPage(1)
            navigate(`/admin/tour?page=1`)
        }
        setSort(e.target.value)
    }
    const handleChangeSearchInput = (e) => {
        if (currentPage > 1) {
            setCurrentPage(1)
            navigate(`/admin/tour?page=1`)
        }
        setQueryInput(e.target.value)
    }
    const handleChangePaginate = (event, pageNumber) => {
        setCurrentPage(pageNumber)
        navigate(`/admin/tour?page=${pageNumber}`)
    }
    const handleSetShowModalImg = (selectedId) => {
        setSelectedIdImg(selectedId)
        setShowModalImg(!showModalImg)
    }


    const handleHiddenForm = () => {
        setSelectedId(null)
        setShowModal(!showModal)
    }

    const handleShowAddModal = () => {
        setMethod('add')
        setShowModal(!showModal)
    }
    const handleShowDetailModal = (selectedId) => {
        setSelectedId(selectedId)
        setMethod('show')
        setShowModal(!showModal)
    }
    const handleShowModalSchedule = (selectedId) => {
        setSelectedId(selectedId)
        setShowModalSchedule(true)
    }

    const handleShowUpdateModal = (selectedId) => {
        setSelectedId(selectedId)
        setMethod('update')
        setShowModal(!showModal)
    }

    const handleShowRemoveModal = (selectedId) => {
        setSelectedId(selectedId)
        setMethod('remove')
        setShowModal(!showModal)
    }
    const handleHiddenModalImg = () => {
        setShowModalImg(!showModalImg)
        setSelectedIdImg(null)
        setMethod('show-img')
    }
    const handleHiddenModalSchedule = () => {
        setShowModalSchedule(!showModalSchedule)

    }
    const columns = [
        {
            title: 'Mã tour',
            dataIndex: 'tour_id',
            key: 'tour_id',
            align: "center"
        },
        {
            title: 'Tên tour',
            dataIndex: 'tour_name',
            key: 'tour_name',
            align: "center"
        },
        {
            title: 'Thể loại',
            dataIndex: 'tour_type_name',
            key: 'tour_type_name',
            align: "center"
        },
        {
            title: 'Người thêm',
            dataIndex: 'account_name',
            key: 'account_name',
            align: "center"
        },
        {
            title: 'Ngày tạo',
            dataIndex: 'created_at',
            key: 'created_at',
            align: "center"
        },
        {
            title: 'Giá tour (Vnd)',
            key: 'price',
            render: ({ price }) => (
                <span>{setPrice(price)}</span>
            )
        },
        {
            title: 'Số người tối thiểu',
            dataIndex: 'min_person',
            key: 'min_person',
            align: "center"
        },
        {
            title: 'Số người tối đa',
            dataIndex: 'max_person',
            key: 'max_person',
            align: "center"
        },
        {
            title: 'Chỗ trống còn lại',
            key: 'remaining_quantity',
            align: "center",
            render: (_, { remaining_quantity }) => (
                remaining_quantity <= 0 ? 0 : remaining_quantity
            ),
        },
        {
            title: 'Trạng thái',
            key: 'status',
            dataIndex: 'status',
            render: (_, { status }) => (
                // eslint-disable-next-line eqeqeq
                status == 0 ? 'Hoạt động' : 'Tạm dừng'
            ),
        },
        {
            title: 'Thao tác',
            key: 'action',
            align: 'center',
            render: (_, { tour_id }) => (
                <>
                    {/* <ButtonIcon
                        onClick={() => handleShowDetailModal(tour_id)}
                        icon={<FaEye />}
                        description='Chi tiết'
                        classButton="action-primary btn-action"
                    /> */}
                    <ButtonIcon
                        onClick={() => handleSetShowModalImg(tour_id)}
                        icon={<FaImages />}
                        description='Hình ảnh mô tả'
                        classButton="action-danger btn-action"
                    />
                    <ButtonIcon
                        onClick={() => handleShowModalSchedule(tour_id)}
                        icon={<FaExchangeAlt />}
                        description='Lịch trình'
                        classButton="action-primary btn-action"
                    />
                    <ButtonIcon
                        onClick={() => handleShowUpdateModal(tour_id)}
                        icon={<FaRegEdit />}
                        description='Sửa'
                        classButton="action-danger-2 btn-action"
                    />
                    <ButtonIcon
                        onClick={() => handleShowRemoveModal(tour_id)}
                        icon={<FaTrashAlt />}
                        description='Xóa'
                        classButton="action-danger btn-action"

                    />
                </>
            ),
        },
    ];

    useMemo(() => {
        if (currentPage > 1) {
            setTotalItemInPage((currentPage - 1) * 5 + tourState.tourList.length)
        }
        else {
            setTotalItemInPage(tourState.tourList.length)
        }
    }, [currentPage, tourState.tourList.length])

    return (
        <TourWrapper className="admin_tour">
            <div className="admin_tour_control py-0 px-15">
                <div className="admin_tour_control py-0 px-15">
                    <FormSearch
                        placeholder='Tìm kiếm tour...'
                        queryInput={queryInput}
                        onChange={handleChangeSearchInput}
                        setQueryInput={setQueryInput}
                    />

                </div>
                <div className="admin_tour_control_sort-add">
                    <div className="admin_tour_control_sort-add">
                        <select className="mr-15 px-10" value={sort} onChange={handleChangeSort}>
                            <option value='ASC'>Giá thấp đến cao</option>
                            <option value='DESC'>Giá cao xuống thấp</option>
                        </select>
                    </div>
                    <div className="admin_tour_control_sort-add">
                        <select className="mr-15 px-10" value={tourType} onChange={handleChangeTourType}>
                            <option value='all'>Toàn bộ</option>
                            {
                                tourTypeState.toutTypeListAll.map((item, index) => (
                                    <option value={item.id} key={index}>{item.name}</option>
                                ))
                            }
                        </select>
                    </div>
                    <ButtonIcon
                        onClick={handleShowAddModal}
                        icon={<FaPlus />}
                        description="Thêm mới"
                        classButton="btn_add action-danger-1"
                    />
                </div>
            </div>
            <div className="admin_tour_table">

                {
                    tourState.isFetching &&
                    < Loading />
                }
                <TableComponent
                    columns={columns}
                    data={tourState.tourList}
                />
            </div>
            {
                tourState.tourList.length > 0 &&
                <div className="admin_tour_pagination mt-15 px-15">
                    <span className="admin_tour_pagination_total_item medium">
                        {totalItemInPage} / {tourState.totalItem}
                    </span>
                    {
                        tourState.totalPage > 1 &&
                        <Pagination count={tourState.totalPage} color="primary"
                            onChange={(event, pageNumber) => handleChangePaginate(event, pageNumber)}
                            page={currentPage}
                        />
                    }
                </div>
            }
            <Modal
                selectedId={selectedId}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                tourTypeData={tourTypeState.toutTypeListAll}
                showModal={showModal}
                tourType={tourType}
                hidden={handleHiddenForm}
                method={method}
                querySearch={querySearch}
                sort={sort}
            />
            <ModalImageDescription
                showModalImg={showModalImg}
                hidden={handleHiddenModalImg}
                selectedId={selectedIdImg}
            />
            <ModalSchedule
                selectedId={selectedId}
                showModal={showModalSchedule}
                hidden={handleHiddenModalSchedule}
            />
        </TourWrapper>
    );
}

export default Tour;